import script from "./esAppointmentTypeForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esAppointmentTypeForm.vue?vue&type=script&setup=true&lang=ts"

import "./esAppointmentTypeForm.vue?vue&type=style&index=0&id=32d0ba9e&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d0ba9e"]])

export default __exports__